import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { SecurityService } from '../security.service';
import { CanActivateFn } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

// For Angular 14+ with functional guards
export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
) => {
  const security = inject(SecurityService);
  const snackBar = inject(MatSnackBar);

  const permission = route.data['permission'];
  const role = route.data['role'];

  if (!permission && !role) {
    return true;
  }

  let hasAccess = false;

  if (permission) {
    hasAccess = await security.hasPermission(permission);
  }

  if (role) {
    hasAccess = await security.hasRole(role);
  }

  if (!hasAccess) {
    // Optionally redirect to a forbidden page or login
    // router.navigate(['/forbidden']);
    snackBar.open('You do not have access to this page', 'OK', {
      duration: 5000,
    });
    return false;
  }


  return true;
};
